<template>
    <div class="flex flex-wrap gap-4" v-if="availableColors.length > 0">
        <color-swatch
            v-for="color in availableColors"
            :key="color"
            :color="color"
            :disabled="loadedFromRecipe"
            :is-selected="color.text === selectedColor"
            @select="selectColor(color)"
        />
    </div>
</template>

<script>
    import ColorSwatch from './ColorSwatch.vue';

    import allStores from '../../../stores/all';

    export default {
        mixins: [allStores],

        components: { ColorSwatch },

        props: {
            selectedColor: {
                type: String,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            loadedFromRecipe() {
                return this.customizerStore.loadedFromRecipe;
            },

            availableColors() {
                return this.customizerStore.availablePersonalizationColors;
            },
        },

        methods: {
            selectColor(color) {
                if (!this.viewController.updateSimilarComponent('ProductColor', color.definition, color.value)) {
                    this.viewController.updateComponent('ProductColor', color.selectable.safeSelection);
                }
            },
        },
    };
</script>
